import { render, staticRenderFns } from "./AppNavigation.vue?vue&type=template&id=1be2c12e&scoped=true"
import script from "./AppNavigation.vue?vue&type=script&lang=js"
export * from "./AppNavigation.vue?vue&type=script&lang=js"
import style0 from "./AppNavigation.vue?vue&type=style&index=0&id=1be2c12e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1be2c12e",
  null
  
)

export default component.exports